import { render, staticRenderFns } from "./SystemInformList.vue?vue&type=template&id=b8ccb5a4&scoped=true"
import script from "./SystemInformList.vue?vue&type=script&lang=js"
export * from "./SystemInformList.vue?vue&type=script&lang=js"
import style0 from "./SystemInformList.vue?vue&type=style&index=0&id=b8ccb5a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ccb5a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ccb5a4')) {
      api.createRecord('b8ccb5a4', component.options)
    } else {
      api.reload('b8ccb5a4', component.options)
    }
    module.hot.accept("./SystemInformList.vue?vue&type=template&id=b8ccb5a4&scoped=true", function () {
      api.rerender('b8ccb5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/SystemInformList/SystemInformList.vue"
export default component.exports